<isav-advanced-search
    *ngIf="searchState | async as searchState"
    [state]="searchState"
    viewModes="All"
>
    <isav-advanced-search-filters [isavRestrictTaxonomies]="apiParams">
        <form [formGroup]="filters" (ngSubmit)="search()">
            <div class="field">
                <label for="textinput">Text</label>
                <div class="control is-fullwidth">
                    <input
                        id="textinput"
                        type="text"
                        class="input"
                        formControlName="text"
                        placeholder="Type text to search for data links"
                        aria-label="Type text to search for data links"
                        data-testid="textinput"
                    />
                </div>
            </div>
            <div class="field">
                <label for="startdateinput">Start date</label>
                <div class="control is-fullwidth">
                    <input
                        id="startdateinput"
                        type="date"
                        class="input"
                        formControlName="startDate"
                        aria-label="Type start date"
                        data-testid="startdateinput"
                    />
                </div>
            </div>
            <div class="field">
                <label for="enddateinput">End date</label>
                <div class="control is-fullwidth">
                    <input
                        id="enddateinput"
                        type="date"
                        class="input"
                        formControlName="endDate"
                        aria-label="Type end date"
                        data-testid="enddateinput"
                    />
                </div>
            </div>

            <div class="field">
                <label for="selectTopic">Select topics</label>
                <div class="control">
                    <isav-taxonomy-select
                        id="selectTopic"
                        formControlName="topic"
                        taxonomy="Topic"
                        placeholder="Select topics"
                        [multiple]="true"
                    ></isav-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <label for="selectOrganisation">Select organisation</label>
                <div class="control">
                    <isav-taxonomy-select
                        [id]="'selectOrganisation'"
                        formControlName="organisation"
                        taxonomy="Organisation"
                        placeholder="Select organisation"
                    ></isav-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <label for="selectDepartment">Select departments</label>
                <div class="control">
                    <isav-department-select
                        [id]="'selectDepartment'"
                        formControlName="departments"
                        placeholder="Select departments"
                        [multiple]="true"
                        [organisationIri]="filters.value.organisation"
                    ></isav-department-select>
                </div>
            </div>

            <div class="field">
                <label for="selectTheme">Select theme</label>
                <div class="control">
                    <isav-taxonomy-select
                        [id]="'selectTheme'"
                        formControlName="theme"
                        taxonomy="Theme"
                        placeholder="Select theme"
                    ></isav-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <label for="selectCountry">Select country</label>
                <div class="control">
                    <isav-taxonomy-select
                        [id]="'selectCountry'"
                        formControlName="country"
                        taxonomy="RegisteredCountry"
                        placeholder="Select country"
                    ></isav-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <div class="control">
                    <button isavBtn color="success" type="submit" class="is-fullwidth">
                        Search
                    </button>
                </div>
            </div>
            <div class="field">
                <div class="control has-text-centered has-text-white">
                    <button
                        isavBtn
                        color="transparent"
                        type="button"
                        (click)="resetFilters()"
                        data-testid="resetbtn"
                    >
                        Reset
                    </button>
                </div>
            </div>
        </form>
    </isav-advanced-search-filters>

    <isav-advanced-search-title>Data-Links</isav-advanced-search-title>

    <table
        *isavAdvancedSearchListView
        isav-table
        [data]="searchState.results.member"
        class="is-hoverable is-fullwidth"
    >
        <ng-container isavColumnDef="fullNameOfDataSet">
            <th isav-header-cell isav-sort-header-cell="fullNameOfDataSet" *isavHeaderCellDef>
                Title
            </th>
            <td isav-cell *isavCellDef="let row">
                <a
                    [routerLink]="row.fullNameOfDataSet | isavViewLink : 'datalinks'"
                    [queryParams]="{ iri: row['@id'] }"
                >
                    {{ row.fullNameOfDataSet }}
                </a>
            </td>
        </ng-container>

        <ng-container isavColumnDef="startDate">
            <th
                class="narrow-col"
                isav-header-cell
                isav-sort-header-cell="startDate"
                *isavHeaderCellDef
            >
                Start Date
            </th>
            <td class="narrow-col" isav-cell *isavCellDef="let row">
                {{ row.startDate | isavDate }}
            </td>
        </ng-container>

        <ng-container isavColumnDef="endDate">
            <th
                class="narrow-col"
                isav-header-cell
                isav-sort-header-cell="endDate"
                *isavHeaderCellDef
            >
                End Date
            </th>
            <td class="narrow-col" isav-cell *isavCellDef="let row">
                {{ row.endDate | isavDate }}
            </td>
        </ng-container>

        <ng-container isavColumnDef="organisation">
            <th isav-header-cell isav-sort-header-cell="organisation.title" *isavHeaderCellDef>
                Organisation
            </th>
            <td isav-cell *isavCellDef="let row">
                <isav-taxonomies-names
                    property="title"
                    [iris]="[row.organisation]"
                ></isav-taxonomies-names>
            </td>
        </ng-container>

        <ng-container isavColumnDef="theme">
            <th isav-header-cell isav-sort-header-cell="theme.name" *isavHeaderCellDef>Theme</th>
            <td isav-cell *isavCellDef="let row">
                <isav-taxonomies-names [iris]="[row.theme]"></isav-taxonomies-names>
            </td>
        </ng-container>

        <ng-container isavColumnDef="topic">
            <th isav-header-cell *isavHeaderCellDef>Topics</th>
            <td isav-cell *isavCellDef="let row">
                <isav-taxonomies-names [limit]="true" [iris]="row.topics"></isav-taxonomies-names>
            </td>
        </ng-container>

        <tr isav-header-row *isavHeaderRowDef></tr>
        <tr
            isav-row
            *isavRowDef="let row; columns: ['fullNameOfDataSet', 'startDate', 'endDate',
                'topic', 'theme', 'organisation']"
        ></tr>
    </table>

    <isav-timeline
        *isavAdvancedSearchTimelineView
        [data]="searchState.results.member"
    ></isav-timeline>

    <isav-map [showTypeSelect]="true" *isavAdvancedSearchMapView>
        <isav-map-location-search-highlight></isav-map-location-search-highlight>
        <isav-map-markers-creation></isav-map-markers-creation>
        <isav-map-markers-display></isav-map-markers-display>
        <isav-map-clustered-vector-layer>
            <isav-map-marker
                *ngFor="let datalink of searchState.results.member"
                [coordinate]="datalink.location | isavMapCoordinate"
            >
                <a
                    *isavMapOverlayContent
                    [routerLink]="datalink.fullNameOfDataSet | isavViewLink : 'datalinks'"
                    [queryParams]="{ iri: datalink['@id'] }"
                    class="is-block"
                >
                    {{ datalink.fullNameOfDataSet | isavTitleFallback : datalink['@id'] }}
                </a>
            </isav-map-marker>
        </isav-map-clustered-vector-layer>
    </isav-map>

    <ng-container *isavAdvancedSearchCardView>
        <div class="columns is-multiline">
            <isav-landing-card
                *ngFor="let datalink of searchState.results.member"
                [image]="datalink.image"
            >
                <ng-container isavLandingCardCaption>
                    <b>{{ datalink.startDate | isavDate }}</b>
                    <span>&nbsp;-&nbsp;</span>
                    <b>{{ datalink.endDate | isavDate }}</b>
                </ng-container>
                <a
                    isavLandingCardHeading
                    [routerLink]="datalink.fullNameOfDataSet | isavViewLink : 'datalinks'"
                    [queryParams]="{ iri: datalink['@id'] }"
                >
                    {{ datalink.fullNameOfDataSet }}
                </a>
                <div isavLandingCardFooter class="columns">
                    <div class="column">
                        <b>Theme:&nbsp;</b><br />
                        <isav-taxonomies-names [iris]="[datalink.theme]"> </isav-taxonomies-names>
                    </div>
                    <div class="column">
                        <b>Topics:&nbsp;</b><br />
                        <isav-taxonomies-names
                            [limit]="true"
                            [iris]="datalink.topics"
                        ></isav-taxonomies-names>
                    </div>
                </div>
            </isav-landing-card>
        </div>
    </ng-container>
</isav-advanced-search>
